export const complexIconMoonName = [
  'icon-1',
  'icon-2',
  'icon-3',
  'icon-4',
  'icon-5',
  'icon-6',
  'icon-7',
  'icon-8',
  'icon-9',
  'icon-uy',
  'icon-us',
  'icon-pe',
  'icon-x',
]

const simpleIcoMoonnName = [
  'icon-cerrar',
  'icon-mas',
  'icon-language-white',
  'icon-language',
  'icon-arrow-1',
  'icon-arrow-2',
  'icon-arrow-green-left',
  'icon-arrow-green-right',
  'icon-arrow-red-1',
  'icon-arrow-red-2',
  'icon-arrow-white-1',
  'icon-arrow-white-2',
  'icon-check-green',
  'icon-check-white',
  'icon-chevron-down',
  'icon-chevron-right',
  'icon-chevron-up',
  'icon-cross-white',
  'icon-cross',
  'icon-gear',
  'icon-menu',
  'icon-help',
  'icon-profile',
  'icon-shine',
  'icon-check-circle',
  'icon-calendar-today',
  'icon-bell',
  'icon-check-circle-unabled',
  'icon-check-circle-yellow',
  'icon-check-circle-outline',
  'icon-language1',
  'icon-search',
  'icon-refresh',
  'icon-help-bubble',
  'icon-doc-link',
  'icon-file',
  'icon-link',
  'icon-cancel',
]

export const validIconMoonName = [
  ...simpleIcoMoonnName,
  ...complexIconMoonName,
] as const

export const validIconMoonSize = ['xs', 'sm', 'md', 'lg', 'xl'] as const
